module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"sites":"Märkte"},"en":{"sites":"Sites"}}')
  delete Component.options._Ctor
}
